// @flow
import {compose, defaultTo, head, toLower} from 'ramda'

const splitOnNonWordChars = (str) => str.match(/\b\S+\b/g) || ['']

// Present participle rather than a gerund
const isPresentParticiple = compose(
  (str) => str.endsWith('ing'),
  head,
  splitOnNonWordChars,
  toLower,
  defaultTo(''),
)

function isValidAccountability(str: string, locale: string, checkingEnabled: boolean): any | boolean {
  if (String(str || '') === '')
    return true
  if (locale !== 'en')
    return true
  if (!checkingEnabled)
    return true
  return isPresentParticiple(str)
}

export default isValidAccountability
